import React, { useState, useEffect } from "react";

import {
  Box,
  Grid,
  Button,
  ButtonGroup,
  FormLabel,
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Fade,
  Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Usuarios from "../UsuariosCRM/Usuarios";
import Oficinas from "../Oficinas/Oficinas";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import { useSearchParams } from "react-router-dom";
import api from "../../api/axios";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

const Ver = () => {
  const { goTable, goEdit } = useLocationHelpers();

  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("id");

  const [usersControlNumber, setUsersControlNumber] = useState(-1);
  const [flagActiveUsers, setFlagActiveUsers] = useState(true);

  const [officesControlNumber, setOfficesControlNumber] = useState(-1);
  const [flagActiveOffices, setFlagActiveOffices] = useState(true);

  const [companyData, setCompanyData] = useState({
    companyEmail: "",
    companyName: "",
    companyProvince: null, // Cambiado a null para manejar Autocomplete
    companyAddress: "",
    companyPostalCode: "",
    companyCif: "",
    companyPhone: "",
    companyContactPerson: "",
  });

  const [flag, setFlag] = useState(false);

  // Obtener los datos de la empresa
  const getDataCompanies = async () => {
    setFlag(true);
    const url = `${process.env.REACT_APP_API_URL}/companies/show`;

    try {
      const response = await api.post(url, { company: companyId });
      console.log(response);

      const {
        company_email,
        company_name,
        company_province,
        company_address,
        company_postalcode,
        company_cif,
        company_phone,
        company_contactname,
        company_logo,
      } = response.data.company;

      setCompanyData({
        companyEmail: company_email,
        companyName: company_name,
        companyProvince: company_province,
        companyAddress: company_address,
        companyPostalCode: company_postalcode,
        companyCif: company_cif,
        companyPhone: company_phone,
        companyContactPerson: company_contactname,
        companyLogo: company_logo,
      });
    } catch (error) {
      console.error("Error fetching company data:", error); // Mensaje de error más descriptivo
    } finally {
      setFlag(false); // Asegurarse de desactivar la bandera en caso de error o éxito
    }
  };

  useEffect(() => {
    getDataCompanies();
  }, [companyId]);

  const ImageCell = () => (
    <img
      src={`${process.env.REACT_APP_BACKEND_HOST}/storage/company/${
        companyId + "/" + companyData.companyLogo
      }`}
      alt="Company logo"
      className="image-views"
    />
  );

  const labels = {
    companyName: "Nombre de Empresa",
    companyEmail: "Correo",
    companyProvince: "Provincia",
    companyAddress: "Dirección",
    companyPostalCode: "Código Postal",
    companyCif: "CIF",
    companyPhone: "Teléfono",
    companyContactPerson: "Contacto",
    companyLogo: "Imagen",
  };

  useEffect(() => {
    console.log(officesControlNumber);
    if (officesControlNumber === 0) {
      setFlagActiveOffices(false);
    } else {
      setFlagActiveOffices(true);
    }
    // eslint-disable-next-line
  }, [officesControlNumber]);

  useEffect(() => {
    console.log(usersControlNumber);
    if (usersControlNumber === 0) {
      setFlagActiveUsers(false);
    } else {
      setFlagActiveUsers(true);
    }
    // eslint-disable-next-line
  }, [usersControlNumber]);

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Empresas" subTitle="Ver" />

      {flag && <LoadingPage isLoading={flag} heightProp={"80vh"} />}
      <Fade in={!flag} timeout={800}>
        <div>
          <Box
            component="form"
            sx={{ margin: "auto", "& > :not(style)": {} }}
            noValidate
            autoComplete="off"
            className="formMainContainer">
            {!flag && (
              <Grid
                container
                style={{ textAlign: "center" }}
                p={2}
                className="fontSize">
                <Grid item xs={12} md={4} className="image-view-container">
                  {ImageCell()}
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  md={8}
                  sx={{
                    textAlign: "left",
                    padding: "10px",
                  }}>
                  {Object.entries(companyData).map(([key, value]) => (
                    <Grid item xs={12} textAlign={"left"} key={key}>
                      <FormLabel>
                        <b> {`${labels[key]}:`} </b> {`${value}`}{" "}
                      </FormLabel>
                    </Grid>
                  ))}
                </Grid>
                <Grid item xs={12}>
                  <ButtonGroup
                    sx={{
                      width: "100%",
                      justifyContent: "center",
                      textAlign: "center",
                      margin: "20px auto 0px auto",
                    }}>
                    <Button
                      sx={{ width: "100%" }}
                      onClick={() => goEdit("empresas", companyId, "Empresa")}
                      variant="outlined"
                      color="success">
                      Editar
                    </Button>
                    <Button
                      sx={{ width: "100%" }}
                      onClick={() => goTable("empresas", "Empresas")}
                      variant="outlined"
                      color="error">
                      Tabla
                    </Button>
                  </ButtonGroup>
                </Grid>
              </Grid>
            )}
          </Box>
          <Box
            component="form"
            sx={{ margin: "auto", "& > :not(style)": {} }}
            noValidate
            autoComplete="off"
            className="formMainContainer">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header">
                Usuarios {companyData?.companyName}
              </AccordionSummary>
              <AccordionDetails>
                {flagActiveUsers ? (
                  <Usuarios
                    flagToShow={false}
                    setCompanyFromUser={companyId}
                    setUsersControlNumber={setUsersControlNumber}
                  />
                ) : (
                  <Alert color="info" severity="info">
                    {" "}
                    Sin usuarios asociados...
                  </Alert>
                )}
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header">
                Oficinas {companyData?.companyName}
              </AccordionSummary>
              <AccordionDetails>
                {flagActiveOffices ? (
                  <Oficinas
                    flagToShow={false}
                    setCompanyFromUser={companyId}
                    setOfficesControlNumber={setOfficesControlNumber}
                  />
                ) : (
                  <Alert color="info" severity="info">
                    {" "}
                    Sin oficinas asociadas...
                  </Alert>
                )}
              </AccordionDetails>
            </Accordion>
          </Box>
        </div>
      </Fade>
    </div>
  );
};

export default Ver;
